<div class="title-emphasis">
  <i class="title-ico anticon anticon-file-protect"></i>
  <div>
    <h4 class="p-0 m-0">Underwriting Worksheet</h4>
    <span class="col-grey-dark">P0000107</span>
  </div>
</div>

<!-- Summary -->
<div class="summary-container">
  <div>
    <span class="s-c-head">Policy No</span> P0000107
  </div>
  <div>
    <span class="s-c-head">Policy Owner</span>
    <a (click)="profilePanel(1)">Aman Patil</a>
  </div>
  <div>
    <span class="s-c-head">Product</span> StandardLife
  </div>
  <div>
    <span class="s-c-head">Plan</span> Individual
  </div>
  <div>
    <span class="s-c-head">Package</span> SILVER
  </div>
  <div>
    <span class="s-c-head">Premium Status</span>
    <nz-tag [nzColor]="'#87d068'">PAID</nz-tag>
  </div>
  <div>
    <span class="s-c-head">Commencement Date</span>
    13-11-2018 <small class="d-b">(~5 months ago)</small>
  </div>
  <div>
    <span class="s-c-head">Policy Expiry Date</span>
    <nz-badge nzStatus="success">12-11-2019 </nz-badge>
    <small class="d-b">(in 6 months)</small>
  </div>
  <div>
    <span class="s-c-head">Total Sum Insured</span> Rs 1 Cr.
  </div>
  <div>
    <span class="s-c-head">Premium</span> Rs 5400
  </div>
</div>

<!-- TimeLines -->
<h4 class="p-t-b-20 d-b">Activity Timeline</h4>
<app-claims-activity-timeline [IO]="IO" [DO]="'proposalDO'" [transactionState]="transactionState"></app-claims-activity-timeline>
<!-- <nz-timeline>
  <nz-timeline-item nzColor="orange">
    <h4 class="f-w-600">Investigation <nz-tag [nzColor]="'orange'">Pending</nz-tag>
    </h4>
    <p><i class="anticon anticon-calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
    <p>
      Investigator: G. Fadango <br>
      Status: Being Investigated
    </p>
  </nz-timeline-item>
  <nz-timeline-item nzColor="orange">
    <h4 class="f-w-600">Missing Document <nz-tag [nzColor]="'orange'">Pending</nz-tag>
    </h4>
    <p><i class="anticon anticon-calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
    <p>
      Notes: Correspondence sent to Claimant
    </p>
  </nz-timeline-item>
  <nz-timeline-item nzColor="green">
    <h4 class="f-w-600">eMail to Claimant <nz-tag [nzColor]="'green'">Sent</nz-tag>
    </h4>
    <p><i class="anticon anticon-calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
    <p>
      To: riya@gmail.com <br>
      Message: Your claim is being processed <br>
      Attachment: <a>CLM0000107.EML</a>
    </p>
  </nz-timeline-item>

</nz-timeline> -->